import { useEffect, useState } from "react";

const TARGET = new Date("2027-05-22T16:30:00-04:00").getTime();

const calc = () => {
  const diff = Math.max(0, TARGET - Date.now());
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
};

export const Countdown = ({ variant = "band" }) => {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: "Days", v: t.d },
    { label: "Hours", v: t.h },
    { label: "Minutes", v: t.m },
    { label: "Seconds", v: t.s },
  ];

  if (variant === "hero") {
    return (
      <div className="flex gap-4 md:gap-6" data-testid="countdown-hero">
        {units.map((u) => (
          <div key={u.label} className="text-cream">
            <span className="font-display text-3xl md:text-5xl">{String(u.v).padStart(2, "0")}</span>
            <span className="block text-[0.6rem] tracking-[0.2em] uppercase text-cream/70">{u.label}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <section className="bg-avocado text-cream border-y-2 border-ink" data-testid="countdown-band">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-12 md:py-16 flex flex-col md:flex-row md:items-center justify-between gap-8">
        <div>
          <p className="overline text-yellow">The countdown</p>
          <p className="font-display text-3xl md:text-5xl mt-3 leading-[1.15] pb-2">Until we say "I do"</p>
        </div>
        <div className="flex gap-5 md:gap-8">
          {units.map((u) => (
            <div key={u.label} className="text-center">
              <span className="font-display text-4xl md:text-6xl text-yellow">{String(u.v).padStart(2, "0")}</span>
              <span className="block text-xs tracking-[0.2em] uppercase text-cream/70 mt-1">{u.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
